module.exports = __webpack_public_path__ + "static/media/Background_Top.79849824.webp";